export default {
  apiKey: 'AIzaSyBn1iu50klAXfy8SrgdjseyY7wfxgkytXI',
  authDomain: 'news-briefer.firebaseapp.com',
  databaseURL: 'https://news-briefer.firebaseio.com',
  projectId: 'news-briefer',
  storageBucket: 'news-briefer.appspot.com',
  messagingSenderId: '661008823448',
  appId: '1:661008823448:web:9d327aff61abf327de0ced',
  measurementId: 'G-RZ4J5PMLN6',
};
